export class WePayEnvironment {
    public static Staging = 'stage';
    public static Production = 'prod';
}
